<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "Cancel-Order",
        "hide-footer": "",
        centered: "",
        size: "md",
        "no-close-on-backdrop": true,
      },
      on: {
        hide: function ($event) {
          return _vm.onModalHidden(false)
        },
      },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _c("h4", { staticClass: "mb-1 text-center head-top-25" }, [
        _vm._v(" " + _vm._s(_vm.$t("sell.Cancellation-Reason")) + " "),
      ]),
      _c(
        "b-form",
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "group-title head-top-20 d-flex justify-content-start",
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("sell.Self")) + " ")]
                ),
                _c(
                  "div",
                  { staticClass: "card-border scroll-comp" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "pl-0", attrs: { md: "12" } },
                      [
                        _c("b-form-radio-group", {
                          attrs: {
                            options: _vm.self,
                            stacked: "",
                            name: "selected-self",
                            "value-field": "id",
                            "text-field": "value",
                          },
                          model: {
                            value: _vm.selectedSelf,
                            callback: function ($$v) {
                              _vm.selectedSelf = $$v
                            },
                            expression: "selectedSelf",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.selfOtherId === _vm.selectedSelf
                      ? _c(
                          "b-col",
                          { staticClass: "mt-1", attrs: { md: "12" } },
                          [
                            _c("b-form-input", {
                              staticClass: "form-control",
                              model: {
                                value: _vm.reason,
                                callback: function ($$v) {
                                  _vm.reason = $$v
                                },
                                expression: "reason",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c(
                  "div",
                  { staticClass: "group-title d-flex justify-content-start" },
                  [_vm._v(" " + _vm._s(_vm.$t("sell.Counter-party")) + " ")]
                ),
                _c(
                  "div",
                  { staticClass: "card-border scroll-comp" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "pl-0", attrs: { md: "12" } },
                      [
                        _c("b-form-radio-group", {
                          attrs: {
                            options: _vm.counterParty,
                            stacked: "",
                            "value-field": "id",
                            "text-field": "value",
                            name: "selected-counter-party",
                          },
                          model: {
                            value: _vm.selectedCounterParty,
                            callback: function ($$v) {
                              _vm.selectedCounterParty = $$v
                            },
                            expression: "selectedCounterParty",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.counterPartyId === _vm.selectedCounterParty
                      ? _c(
                          "b-col",
                          { staticClass: "mt-1", attrs: { md: "12" } },
                          [
                            _c("b-form-input", {
                              staticClass: "form-control",
                              model: {
                                value: _vm.reason,
                                callback: function ($$v) {
                                  _vm.reason = $$v
                                },
                                expression: "reason",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "text-center mt-2 mb-1", attrs: { md: "12" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "n-wrap",
                      attrs: {
                        disabled:
                          !_vm.selectedCounterParty && !_vm.selectedSelf,
                        variant: "primary",
                      },
                      on: { click: _vm.cancelOrder },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("sell.Confirm-Cancellation")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/CancelOrder/CancelOrder.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import * as vuex from 'vuex';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import libs_api_api from '@/libs/api/api';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





export default ({
  render,
  staticRenderFns,
  components: {
    BModal: bootstrapvue["BModal"],
    BButton: bootstrapvue["BButton"],
    BFormRadioGroup: bootstrapvue["BFormRadioGroup"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BForm: bootstrapvue["BForm"],
    BFormInput: bootstrapvue["BFormInput"]
  },
  data() {
    return {
      modalVisible: this.showPop,
      selectedSelf: "",
      self: [],
      selectedCounterParty: "",
      counterParty: [],
      selfOtherId: "",
      counterPartyId: "",
      reason: ""
    };
  },
  computed: {
    ...vuex.mapState("user", ["refData"]),
    buttonVariant() {
      return this.orderType === "BUY" ? "primary" : "danger";
    },
    buttonLabel() {
      const action = this.orderType === "BUY" ? this.$t("buy.Buy") : this.$t("buy.Sell");
      return `${action} ${this.coin}`;
    }
  },
  mounted() {
    this.setOptionsList();
  },
  watch: {
    showPop(newValue) {
      this.modalVisible = newValue;
    },
    refData(newVal) {
      this.setOptionsList();
    },
    selectedCounterParty(newVal, oldValue) {
      if (newVal && oldValue !== newVal) {
        this.selectedSelf = "";
        this.reason = "";
      }
    },
    selectedSelf(newVal, oldValue) {
      if (newVal && oldValue !== newVal) {
        this.selectedCounterParty = "";
        this.reason = "";
      }
    }
  },
  methods: {
    setOptionsList() {
      if (this.refData && this.refData.orderCancelReason && this.refData.orderCancelReason.buyer && this.cancelType !== "BUY") {
        this.self = this.refData.orderCancelReason.buyer.Self;
        this.counterParty = this.refData.orderCancelReason.buyer.Counterparty;
        this.extractIdFromOtherReason(this.refData.orderCancelReason.buyer.Self, "selfOtherId");
        this.extractIdFromOtherReason(this.refData.orderCancelReason.buyer.Counterparty, "counterPartyId");
      }
      if (this.refData && this.refData.orderCancelReason && this.refData.orderCancelReason.seller && this.cancelType === "SELL") {
        this.self = this.refData.orderCancelReason.seller.Self;
        this.counterParty = this.refData.orderCancelReason.seller.Counterparty;
        this.extractIdFromOtherReason(this.refData.orderCancelReason.seller.Self, "selfOtherId");
        this.extractIdFromOtherReason(this.refData.orderCancelReason.seller.Counterparty, "counterPartyId");
      }
    },
    extractIdFromOtherReason(reasonList, propertyToUpdate) {
      if (reasonList && reasonList.length > 0) {
        reasonList.forEach(item => {
          if (item.value && item.value.toLowerCase() === "other reason") {
            this[propertyToUpdate] = item.id;
          }
        });
      }
    },
    extractValueFromid(reasonList, id) {
      if (reasonList && reasonList.length) {
        for (let i = 0; i < reasonList.length; i++) {
          if (reasonList[i].value && reasonList[i].id === id) {
            return reasonList[i].value;
          }
        }
      }
    },
    async cancelOrder() {
      try {
        let party = "",
          reasonMessage = "",
          reasonCode = "";
        if (this.selectedCounterParty) {
          party = "COUNTER";
          reasonCode = this.selectedCounterParty;
          if (this.selectedCounterParty === this.counterPartyId) {
            reasonMessage = this.reason;
          } else {
            reasonMessage = await this.extractValueFromid(this.counterParty, this.selectedCounterParty);
          }
        } else if (this.selectedSelf) {
          party = "SELF";
          reasonCode = this.selectedSelf;
          if (this.selectedSelf === this.selfOtherId) {
            reasonMessage = this.reason;
          } else {
            reasonMessage = await this.extractValueFromid(this.self, this.selectedSelf);
          }
        }
        const res = await new libs_api_api().api({
          method: "post",
          url: "p2p/order/cancel"
        }, {
          orderId: this.$route.params.id,
          reason: {
            party,
            reasonCode,
            reasonMessage
          }
        }, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus === "SUCCESS") {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: this.$t("sell.OrderCancelSuccessfully"),
              icon: "EditIcon",
              variant: "success"
            }
          });
          this.modalVisible = false;
          this.onModalHidden(false, true);
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    }
  },
  props: {
    showPop: {
      type: Boolean,
      isRequired: false,
      default: false
    },
    onModalHidden: {
      type: Function,
      isRequired: true,
      default: () => {}
    },
    cancelType: {
      type: String,
      isRequired: true,
      default: ""
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/CancelOrder/CancelOrder.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
#Cancel-Order .group-title {
  color: #000000;
  font-size: 16px;
  font-weight: 500;
}[dir] #Cancel-Order .group-title {
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
}
[dir] #Cancel-Order .group-title.head-top-20 {
  margin-top: 0px;
}
#Cancel-Order .card-border {
  width: 100%;
}
[dir] #Cancel-Order .card-border {
  border: 1px solid #d0d0d0;
  padding: 10px;
}
[dir=ltr] #Cancel-Order .card-border {
  box-shadow: 1px 1px 2px #d0d0d0;
}
[dir=rtl] #Cancel-Order .card-border {
  box-shadow: -1px 1px 2px #d0d0d0;
}
#Cancel-Order .scroll-comp {
  max-height: 200px;
  overflow-y: auto;
}
[dir] #Cancel-Order .scroll-comp .custom-radio {
  margin-top: 3px;
  margin-bottom: 8px;
}
</style>
